<sdc-bo-dialog
  headerTitle="Transactions Details"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'transaction-details-modal-' + data?.id">
  @if (data) {
    <div class="mt-6 content-wrapper">
      <div class="seats-detail">
        <span
          ><b>Seats ({{ data.seats.length }})</b></span
        >
        @if (data.seats.length) {
          <div class="seats-wrapper">
            <table class="seats-table">
              <thead>
                <tr>
                  <th>Section</th>
                  <th>Row</th>
                  <th>Seat</th>
                </tr>
              </thead>
              <tbody>
                @for (s of data.seats; track s) {
                  <tr>
                    <td>{{ s[0] }}</td>
                    <td>{{ s[1] }}</td>
                    <td>{{ s[2] }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
      <sdc-info-grid [items]="infoItems" [columns]="2" [emptyValue]="''" />
    </div>
  }

  <div [class.open-log]="isErrorLogOpen" class="error-log-container">
    <div class="error-log-header">
      <p>Error Log</p>
      <button type="button" class="header-icon-btn" (click)="toggleErrorLog()">
        <ng-icon name="lucideX" size="1.25rem"></ng-icon>
      </button>
    </div>
    <div class="default-table">
      <div>
        <table>
          <thead>
            <tr>
              <th>Provenue Request Id</th>
              <th>Error Message</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (e of errors; track e) {
              <tr style="position: relative">
                <td (click)="copyToClipboard(e.pvRequestId)">
                  @if (e.isUnread) {
                    <span class="unread-error-badge"></span>
                  }
                  <div>
                    <span class="text-center">
                      {{ e.pvRequestId }}
                    </span>
                    <span class="copy-container">
                      <ng-icon name="lucideClipboard" size="1rem"> </ng-icon>
                    </span>
                  </div>
                </td>
                <td (click)="copyToClipboard(e.pvMessage)">
                  <div>
                    <span class="text-left">
                      {{ e.pvMessage }}
                    </span>
                    <span class="copy-container">
                      <ng-icon name="lucideClipboard" size="1rem"> </ng-icon>
                    </span>
                  </div>
                </td>
                <td style="padding-right: 10px">
                  <button class="default-2" (click)="openDrawer(e.error)">
                    Details
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <ng-container sdc-bo-dialog-footer>
    <sdc-button variant="primary" (onClick)="onConfirm()">Close</sdc-button>
    <sdc-button variant="destructive" (onClick)="toggleErrorLog()">
      Error Log
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
